/**
 * useAdminStatus - Hook to check if current user is an admin
 * Caches the result to avoid repeated API calls
 */
import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import adminService from '../services/adminService';

const useAdminStatus = () => {
  const { isAuthenticated, firebaseUserId } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  const checkAdmin = useCallback(async () => {
    if (!isAuthenticated || !firebaseUserId) {
      setIsAdmin(false);
      setLoading(false);
      return;
    }

    try {
      const result = await adminService.checkAdminAccess();
      setIsAdmin(result.is_admin === true);
    } catch (error) {
      // 403 means not admin, any other error we assume not admin
      setIsAdmin(false);
    } finally {
      setLoading(false);
    }
  }, [isAuthenticated, firebaseUserId]);

  useEffect(() => {
    checkAdmin();
  }, [checkAdmin]);

  return { isAdmin, loading };
};

export default useAdminStatus;
